import { GridHeader } from "@src/components/tablegrid/header";
import { SimpleTab } from "../../components/dragableTab/simpleTab";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { getTimeSheetQuery } from "../../util/query/timeSheet.query";
import { Avatar, DatePicker, Input, Layout, Popover, Table } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faUser } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import { TimeSheetActionComment } from "./timeSheetActionComment";
import { useDispatch } from "react-redux";
import { updateTimeSheetMutation } from "../../util/mutation/timeSheet.mutation";
import { setNotification } from "@src/middleware/redux/reducers/notification.reducer";
import { useSelector } from "react-redux";
import { GetEmployeeRecord } from "@src/util/query/employee.query";
import Spinner from "@src/components/spinner";
import "./timeSheet.css";
import { useDebounce } from "@src/components/debounceSearch/debounceSearch";
import { useNavigate } from "react-router-dom";
import { Content } from "antd/es/layout/layout";


export const TimeSheet = ()=>{

    const [getTimeSheet, {data: timeSheetData, loading, refetch}] = useLazyQuery(getTimeSheetQuery);

    const empRef = useRef();
    const [employee, setEmployee] = useState("");
    const [empPopover, setEmpPopOver] = useState(false);
    const [selectedEmployee, setSelectedEmployee] = useState("All Employees");

    const statusRef = useRef();
    const [status, setStatus] = useState("All Status");
    const [statusPopover, setStatusPopOver] = useState(false);
    const [statusData, setStatusData] = useState([
        {id: 1, status: 'Pending'},
        {id: 2, status: 'Approved'},
        {id: 3, status: 'Rejected'},
    ]);

    const [day, setDay] = useState(dayjs());
    const [dayPopover, setDayPopOver] = useState(false);
    // const [employeeData, setEmployeeData] = useState([]);


    function truncateText(text, maxWords) {
        // Split the text into an array of words
        const words = text.split(' ');
    
        
        if(words[0]?.length >15){maxWords=2}
        // If the number of words is less than or equal to the maximum allowed, return the original text
        if (words.length <= maxWords) {
        return text;
        }
    
        // Otherwise, join the first "maxWords" words and add ellipsis at the end
        return words.slice(0, maxWords).join(' ') + '...';
    }

    const history = useNavigate();

    const columns = [
        {
            title: "Employee",
            dataIndex: 'employee',
            width:400,
            render: (_, record)=>{
                const showActions = hoveredRow === record.key;
                return (
                    <div style={{display:'flex', alignItems:'center', justifyContent:'space-between'}}>
                        <div style={{lineHeight:'35px'}} className='truncated-text'>
                        {showActions?truncateText(record.employee,3):truncateText(record.employee,3)}
                        </div>

                        {showActions && selectedRowKeys?.length==0 &&
                        <div style={{width:'100%', display:'flex', justifyContent:'flex-end' ,alignItems:'center', columnGap:'10px'}}>
                        <button style={{marginLeft:'10%'}} className="sm-btn" type="link" onClick={()=>  history("/user/schedule",{
                              state: {timelineScheduleId: record?.scheduleId, timelineSelectedSiteId: record?.siteId, timelineSelectedDate: record?.date}
                          })
                        }>
                            Schedule
                        </button>
                        {/* <button  className="sm-btn" type="link" onClick={()=>setProperties(record.key, record.employee)} >
                            Delete
                        </button> */}
                        </div>
                        }
                    </div>
                )
            }
        },
        {
            title: "Date",
            dataIndex: 'date'
        },
        {
            title: "Booked Hours",
            dataIndex: 'bookedHour'
        },
        {
            title: "Worked Hours",
            dataIndex: 'workedHour'
        },
        {
            title: "Status",
            dataIndex: 'status'
        },
        {
            title: "Action By",
            dataIndex: 'actionBy'
        },
        {
            title: "Actions",
            dataIndex: 'actions'
        },
    ]
    



    const [dataSource, setDataSource] = useState([]);
    const [comments, setComments] = useState("");
    const [actionParam, setActionParam] = useState({});

    useEffect(()=>{
        if(timeSheetData?.getTimeSheet?.response){
            setDataSource(timeSheetData?.getTimeSheet?.response?.map((data)=>{
                const Wh1 = dayjs(data?.checkCalls[1]?.actualDate);
                const Wh2 = dayjs(data?.checkCalls[0]?.actualDate);
                const Bh1 = dayjs(data?.scheduleDetail?.firstDate);
                const Bh2 = dayjs(data?.scheduleDetail?.shiftEndDateTime);
                const color = data?.status=="Pending"? "#FFBF00" : data?.status=="Approved"? "rgb(0, 189, 165)" : "#ef4444";

                return(
                    {
                        key: data?._id,
                        employee: (data?.employeeDetail?.firstname || "")+" "+(data?.employeeDetail?.lastname || ""),
                        date: data?.scheduleDetail?.date,
                        scheduleId: data?.scheduleId,
                        siteId: data?.scheduleDetail?.siteId,
                        actionBy: ((data?.approvedByDetail?.firstname || "")+" "+(data?.approvedByDetail?.lastname || "") || "--"),
                        bookedHour: Bh2.diff(Bh1, 'hour', true)?.toFixed(2)+" h",
                        workedHour: Wh1.diff(Wh2, 'hour', true)?.toFixed(2)+" h",
                        status: <span style={{color: color}}>{data?.status}</span>,
                        actions: data?.status=="Pending"?<div style={{display:'flex', gap:'20px'}}>
                            <button style={{background:'rgb(0, 189, 165)', border:'0', color:'white', borderRadius:'4px', padding:'5px', cursor:'pointer'}} onClick={()=>setActionParam({modal: true, timeSheetId:data?._id, status: true})}> Approve </button>
                            <button style={{background:'#ef4444', border:'0', color:'white',  borderRadius:'4px', padding:'5px', cursor:'pointer'}} onClick={()=>setActionParam({modal: true, timeSheetId: data?._id, status: false})}> Reject </button>
                        </div>:
                        "--"
                    }
                );
            }));
        }
    },[timeSheetData?.getTimeSheet?.response]);


    const [updateTimeSheet, {loading: updateTimeSheetLoading}] = useMutation(updateTimeSheetMutation);

    const dispatch = useDispatch();

    const {authenticatedUserDetail} = useSelector(state=>state.userAuthReducer);
    
    const handelSubmit = async()=>{
        try{

            await updateTimeSheet({
                variables:{
                    input:{
                        _id: actionParam?.timeSheetId,
                        status: actionParam?.status? "Approved" : "Rejected",
                        comments,
                        approvedBy: authenticatedUserDetail?.employeeId
                    }
                }
            });

            dispatch(setNotification({
                error: false,
                notificationState: false,
                message: "Timesheet status been updated"
            }));

            setActionParam({});
            await refetch();

        }catch(err){
            dispatch(setNotification({
                error: true,
                notificationState: true,
                message: err.message
            }));
        }
    };

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [search, setSearch] = useState("");
    const debounceSearchValue = useDebounce(search,500);

    const {data: employeeData, loading: employeeDataLoading,} = useQuery(GetEmployeeRecord,{
        variables: {
            input: {
                filters: null,
                pageSize,
                page,
                search: debounceSearchValue
            }
        },
        fetchPolicy: 'cache-and-network',
        skip: !empPopover || debounceSearchValue?.length<2
    });

    
    useEffect(()=>{
        if(search?.length>0){
        setPageSize(20);
        setPage(1);
        }else{
        setPageSize(20);
        }
    },[search]);



    useEffect(()=>{
        getTimeSheet({
            variables:{
                input: {
                    employeeId: selectedEmployee?._id || null,
                    status: status=="All Status" ? null : status,
                    date: day?.toDate()
                }
            }
        });
    },[selectedEmployee, status, day]);


    const [selectedRowKeys, setSelectedRowKeys]=useState([])

    const onSelectChange = (newSelectedRowKeys) => {
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    const [sortedInfo, setSortedInfo] = useState({});

    const handleChange = (pagination, filters, sorter) => {
        setFilteredInfo(filters);
        setSortedInfo(sorter);
    };


    const [hoveredRow, setHoveredRow] = useState(null);
    
    const rowClassName = (record) => {
        return record.key === hoveredRow ? 'hovered-row' : '';
    };


    
    const handleRowMouseEnter = (record) => {
        setHoveredRow(record.key);
    };


    const handleRowMouseLeave = () => {
        setHoveredRow(null);
    };


    return(
        <div className="tablegrid">
            <GridHeader 
                title={"Time Sheet"} 
                to={"/branch/editform"}
                record={dataSource.length} 
                from={"/user/branch"}      
                createAction={()=>{}} 
                actionBtnHide={true}
            />


            <SimpleTab  
                tabname={"All TimeSheet"}
            />

            <div style={{padding:'0 48px 0px'}} className="timeSheet">

                <div className="filter"  >
                    <div className="filter-inner">
                        
                            <div className='left-filter-inner' >
                                {/* <div style={{width: 'max-content'}}>Filter by:</div> */}
                                
                                <div className='filter-item' style={{marginLeft:0, paddingLeft:5}}>
                                    <Popover
                                        open={empPopover}
                                        overlayClassName='settingCustomPopover'
                                        afterOpenChange={() => {
                                            empRef?.current?.focus();
                                        }}
                                        content={
                                            <div>
                                                <div className="popover-search">
                                                <Input
                                                    type="search"
                                                    ref={empRef}
                                                    id="inputSearch"
                                                    name='popoverSearch'
                                                    style={{ width: '100%', backgroundColor: 'white' }}
                                                    className='generic-input-control'
                                                    placeholder="First or Last name..."
                                                    autoFocus={empPopover}
                                                    autoComplete="off"
                                                    value={search}
                                                    onChange={(e) => {
                                                        setSearch(e.target.value)
                                                    }}
                                                    suffix={<FontAwesomeIcon style={{ color: '#0091ae' }} icon={faSearch} />}
                                                />
                                                </div>

                                                <div className="popover-data" style={{maxHeight:'300px', overflow:'scroll'}}>
                                                {/* {localGroup?.length ? ( */}
                                                    <div
                                                        className={selectedEmployee === "All Employees" ? "popoverdataitem popoverdataitem-active" : "popoverdataitem"}
                                                        onClick={() => {
                                                            setSelectedEmployee("All Employees")
                                                        }}
                                                    >
                                                        {"All Employees"}
                                                    </div>

                                                    {
                                                        employeeDataLoading?

                                                        <div style={{display:'flex', justifyContent:'center', margin:'10px'}}>
                                                            <Spinner/>
                                                        </div>
                                                        
                                                        :
                                                        employeeData?.getEmployee?.response?.length>0?
                                                            employeeData?.getEmployee?.response?.map((emp) => (
                                                                <div
                                                                    key={emp._id}
                                                                    className={selectedEmployee?._id === emp._id ? "popoverdataitem popoverdataitem-active" : "popoverdataitem"}
                                                                    onClick={() => {
                                                                        setSelectedEmployee(emp)
                                                                        setEmpPopOver(false);
                                                                    }}
                                                                >
                                                                    <div className='user-avatar' style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', gap:'5px' }}>
                                                                        {
                                                                            emp?.metadata?.imageURL?
                                                                            <Avatar size={"large"} src={emp?.metadata?.imageURL} />
                                                                            :
                                                                            <Avatar size={"large"} style={{background:'rgba(0,0,0,0.25)'}} src={<FontAwesomeIcon icon={faUser}/>} />

                                                                        }
                                                                        <span>{emp.firstname || ""} {emp.lastname||""}</span>
                                                                    </div>
                                                                    
                                                                </div>
                                                            ))
                                                        :
                                                        <div style={{display:'flex', justifyContent:'center', color:'black'}}>
                                                            No employee found. <br/>
                                                        </div>

                                                    }

                                                </div>
                                            </div>
                                        }
                                        trigger="click"
                                        placement='bottom'
                                        onOpenChange={(visible) => {
                                            if (!visible) {
                                                setEmpPopOver(false);
                                                setStatusPopOver(false);
                                                setDayPopOver(false);
                                                setSearch("");
            
                                            }
                                        }}
                                    >
                                        <span className='truncated-text' onClick={() => setEmpPopOver(!empPopover)}>
                                           {selectedEmployee!="All Employees"?( (selectedEmployee.firstname || "" ) +" "+ ( selectedEmployee.lastname||"" )): "All Employees"}
                                        <span className='caret'></span>
                                        </span>
                                    </Popover>
                                </div>


                                <div className='filter-item'>
                                    <Popover
                                        open={statusPopover}
                                        overlayClassName='settingCustomPopover'
                                        afterOpenChange={() => {
                                            statusRef?.current?.focus();
                                        }}
                                        content={
                                        <div>
                                            <div className="popover-search">
                                            <Input
                                                type="search"
                                                ref={statusRef}
                                                id="inputSearch"
                                                name='popoverSearch'
                                                style={{ width: '100%', backgroundColor: 'white' }}
                                                className='generic-input-control'
                                                placeholder="Search..."
                                                autoFocus={statusPopover}
                                                autoComplete="off"
                                                value={search}
                                                onChange={(e) => {
                                                    setSearch(e.target.value);

                                                }}
                                                suffix={<FontAwesomeIcon style={{ color: '#0091ae' }} icon={faSearch} />}
                                            />
                                            </div>

                                            <div className="popover-data">
                                                <div
                                                className={status === "All Status" ? "popoverdataitem popoverdataitem-active" : "popoverdataitem"}
                                                onClick={() => {
                                                    setStatus("All Status");
                                                    setStatusPopOver(false);
                                                }}
                                                >
                                                    {"All Status"}
                                                </div>
                                                {statusData?.filter((s)=> s.status?.toLowerCase().includes(search?.toLowerCase()))?.map((s) => (
                                                    <div
                                                        key={s.id}
                                                        className={status === s.status ? "popoverdataitem popoverdataitem-active" : "popoverdataitem"}
                                                        onClick={() => {
                                                            setStatus(s.status)
                                                            setStatusPopOver(false);
                                                        }}
                                                    >
                                                        {s.status}
                                                    </div>
                                                ))}
                                            </div>

                                        </div>
                                        }
                                        trigger="click"
                                        placement='bottom'
                                        onOpenChange={(visible) => {
                                            if (!visible) {
                                                setEmpPopOver(false);
                                                setStatusPopOver(false);
                                                setDayPopOver(false);
                                                setSearch("");
                                            }
                                        }}
                                    >
                                        <span className='truncated-text' onClick={() => setStatusPopOver(!statusPopover)}>
                                            {status!="All Status"? status :"All Status"}
                                        <span className='caret'></span>
                                        </span>
                                    </Popover>
                                </div>


                                <div className='filter-item ' style={{cursor:'pointer'}}>
                                    <span className='truncated-text'  style={{cursor:'pointer'}} onClick={() => setDayPopOver(!dayPopover)}>
                                            {day? day.format("DD/MM/YYYY") : "All Days"}
                                            <span className='caret'></span>
                                    </span>
                                    <DatePicker
                                        className="dateFilter"
                                        style={{marginLeft:'-90px', opacity: 0, cursor:'pointer'}}
                                        onChange={(e, dateString)=>setDay(e)}
                                        value={day}
                                        format={"DD/MM/YYYY"}
                                    />
                                </div>


                            </div>
                    </div>
                </div>

                    <Table
                        columns={columns}
                        dataSource={dataSource}
                        loading={loading}
                        locale={{emptyText: 'No Timesheet found'}}
                        rowSelection={rowSelection}
                        onRow={(record) => ({
                            onMouseEnter: () => handleRowMouseEnter(record),
                            onMouseLeave: () => handleRowMouseLeave(),
                        })}
                        rowClassName={rowClassName}
                        className="tableView"
                    />
                    

                
          
            </div>


            {
                actionParam?.modal &&
                <TimeSheetActionComment
                    visible={actionParam?.modal}
                    status={actionParam?.status}
                    close={()=>setActionParam(false)}
                    comments={comments}
                    setComments={setComments}
                    handelSubmit={handelSubmit}
                    loading={updateTimeSheetLoading}
                />
            }
            


        </div>
    );

}